import Icon from '@mui/icons-material/Business';

import { CreateCompany } from './CreateCompany';
import { EditCompany } from './EditCompany';
import { ListCompanies } from './ListCompanies';

export const CompanyResourceConfig = {
  create: CreateCompany,
  edit: EditCompany,
  list: ListCompanies,
  icon: Icon,
  name: 'companies',
};
